import { defineMessages } from "react-intl";

const messages = defineMessages({
  labelName: {
    id: "AddOn.CenterAddOnFormik.labelName",
    defaultMessage: "Name",
  },
  labelPrice: {
    id: "AddOn.CenterAddOnFormik.labelPrice",
    defaultMessage: "Price",
  },
  labelStat: {
    id: "AddOn.CenterAddOnFormik.labelStat",
    defaultMessage: "Is STAT add-on",
  },
  labelAppliesTo: {
    id: "AddOn.CenterAddOnFormik.labelAppliesTo",
    defaultMessage: "Applies to",
  },
  labelContactingPatientRequired: {
    id: "AddOn.CenterAddOnFormik.labelContactingPatientRequired",
    defaultMessage: "Requires Contacting Patient",
  },
  labelMarketingText: {
    id: "AddOn.CenterAddOnFormik.labelMarketintText",
    defaultMessage: "Marketing text",
  },
  marketingPlaceholder: {
    id: "AddOn.CenterAddOnFormik.labelMarketingPlaceholder",
    defaultMessage: "Add content...",
  },
  labelIsPerStudyPricing: {
    id: "AddOn.CenterAddOnFormik.labelIsPerStudyPricing",
    defaultMessage: "Per-study pricing",
  },
  labelVisibility: {
    id: "AddOn.CenterAddOnFormik.labelVisibility",
    defaultMessage: "Type",
  },
  labelVisibilityPublic: {
    id: "AddOn.CenterAddOnFormik.labelVisibilityPublic",
    defaultMessage: "Public",
  },
  labelVisibilityPrivate: {
    id: "AddOn.CenterAddOnFormik.labelVisibilityPrivate",
    defaultMessage: "Private",
  },
  labelAllowMultiplePurchases: {
    id: "AddOn.CenterAddOnFormik.labelAllowMultiplePurchases",
    defaultMessage: "Multiple purchases",
  },
});

export default messages;
